import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Toaster from '../../../../../Components/Toaster/Toaster';
import { ICompanyProfileInfoRegister } from '../../../../../Types/RegisterTypes';
import { useCreateSpaceRequirement } from '../../../apiEndpoints/exhibitorApiEndpoints';
import CommonFormBtn from '../../../../../Components/Common/CommonFormBtn';
import AddSpaceRequirements from './AddSpaceRequirments';
import { useNavigate } from 'react-router-dom';

const BookYourSpace = ({ handleClose }: { handleClose?: () => void }) => {
  const { mutate, isPending, isSuccess, data } = useCreateSpaceRequirement();
  const Toast = Toaster();
  const [stalls, setStalls] = useState<number[]>([]);
  useState<ICompanyProfileInfoRegister | null>();
  const { handleSubmit } = useForm();
  const navigate = useNavigate();
  const onSubmit = async () => {
    if (!stalls.length) {
      Toast.fire({
        icon: 'error',
        title: `Please select stall`,
      });

      return;
    }
    mutate({
      data: {
        stalls,
      },
    });
  };

  useEffect(() => {
    if (isSuccess && data) {
      setStalls([]);
      handleClose?.();
      navigate(`/profile/view-billing-info/${data?.data?.invoice_id}`);
    }
  }, [isSuccess, data]);

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <AddSpaceRequirements setStalls={setStalls} stalls={stalls} />
        </div>
        <CommonFormBtn btnText='Book Your Space' loading={isPending} />
      </form>
    </div>
  );
};

export default BookYourSpace;
